import $ from 'jquery';
import Swal from 'sweetalert2';
import { generateGrid } from './generateGrid';
import customLayouts from './customLayouts';

export const downloadGridPdf = async () => {
  Swal.fire({
    text: "Sto generando l'immagine...",
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    confirmButtonColor: '#278e8e',
    didOpen: () => {
      Swal.showLoading();
    },
  });

  const pdfParameters = $('#navbar-submenu-export-provino-output').select2(
    'data'
  );

  const grigliaProvinoFormatId = pdfParameters[0].id;
  const gridGenerator =
    customLayouts[grigliaProvinoFormatId]?.default || generateGrid;

  const pdf = await gridGenerator();
  pdf.pdfGrid.save(pdf.fileName);
  Swal.fire({
    title: 'Fatto!',
    html: "L'immagine &egrave; stata scaricata.",
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
  setTimeout(() => {
    Swal.hideLoading();
  }, 50);
};

export default downloadGridPdf;
